// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1579694328698
      var cssReload = require("../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/views/CheckBalance/CheckBalance.scss
// module id = ./src/views/CheckBalance/CheckBalance.scss
// module chunks = 0